/* © 2023 Promethean. All Rights Reserved.
 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { useRtl } from '../../../rtlProvider';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.min.css';
import { StyledCarouselContainer, StyledCarousel } from './styles';
SwiperCore.use([Navigation, Pagination, Autoplay]);
export var Carousel = function Carousel(_ref) {
  var _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? true : _ref$fullScreen,
    _ref$images = _ref.images,
    images = _ref$images === void 0 ? [] : _ref$images;
  var _useRtl = useRtl(),
    dir = _useRtl.dir,
    transformRTL = _useRtl.transformRTL;
  return /*#__PURE__*/React.createElement(StyledCarouselContainer, {
    className: "EmbersTemplate-marketingCarousel-root",
    fullScreen: fullScreen
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingCarousel-transformed-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingCarousel-transformed-top"
  }, /*#__PURE__*/React.createElement("button", {
    className: "EmbersTemplate-marketingCarousel-swiper-arrow EmbersTemplate-marketingCarousel-swiper-arrow-prev ".concat(transformRTL('icon-chevron-left', 'icon-chevron-right'))
  }), /*#__PURE__*/React.createElement(Swiper, {
    dir: dir,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    },
    effect: "slide",
    pagination: {
      clickable: true,
      el: '.EmbersTemplate-marketingCarousel-pagination',
      type: 'bullets',
      renderBullet: function renderBullet(index, className) {
        return "<span key='dot-".concat(index, "' class='").concat(className, "'></span>");
      }
    },
    navigation: {
      nextEl: '.EmbersTemplate-marketingCarousel-swiper-arrow-next',
      prevEl: '.EmbersTemplate-marketingCarousel-swiper-arrow-prev'
    },
    loop: true,
    className: "EmbersTemplate-marketingCarousel-swiper"
  }, images.map(function (v, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      key: index
    }, /*#__PURE__*/React.createElement(StyledCarousel, null, /*#__PURE__*/React.createElement("img", {
      src: v.src,
      alt: v.alt
    })));
  })), /*#__PURE__*/React.createElement("button", {
    className: "EmbersTemplate-marketingCarousel-swiper-arrow EmbersTemplate-marketingCarousel-swiper-arrow-next ".concat(transformRTL('icon-chevron-right', 'icon-chevron-left'))
  })), /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingCarousel-pagination"
  })));
};